import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { Select } from 'foundations-components/transitional/components/Select';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { saveUserSetting } from 'crm_data/settings/UserSettingsActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import UserSettingsKeys from 'crm_data/settings/UserSettingsKeys';
import I18n from 'I18n';
import TimelineSearchInput from '../../filter/TimelineSearchInput';
import { useMemo, useCallback } from 'react';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import styled from 'foundations-theming/utils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { collapseAll, expandAll, TimelineOwnersFilterDependency, TimelineTeamsFilterDependency, useSelectedTabOrEventFilters, useTimelineDispatch, useTimelineSearch, TimelineActions, useSubjectContext, WithScopes } from 'crm-events-data';
import ExpandCollapseValue from './ExpandCollapseValue';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SetHeightDiv = styled.div.withConfig({
  displayName: "TimelineSearchAndActionsBar__SetHeightDiv",
  componentId: "sc-1f1jyno-0"
})(["box-sizing:content-box;justify-content:space-between;align-items:center;padding-inline:", ";padding-block-end:", ";display:flex;height:40px;"], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['100']);
const dependencies = {
  selectedOwners: TimelineOwnersFilterDependency,
  selectedTeams: TimelineTeamsFilterDependency
};
export function TimelineSearchAndActionsBar({
  isCollapsedByDefault,
  isScoped
}) {
  const {
    objectType,
    subjectId
  } = useSubjectContext();
  const [isSearchInUse] = useTimelineSearch();
  const dispatch = useTimelineDispatch();
  const selectedOwners = useStoreDependency(dependencies.selectedOwners, {
    objectType
  });
  const selectedTeams = useStoreDependency(dependencies.selectedTeams, {
    objectType
  });
  const {
    selectedEventFilters
  } = useSelectedTabOrEventFilters({
    objectType,
    subjectId
  });
  const canViewFullActivityHistory = isScoped('full-activity-history-access');
  const handleExpandCollapseChange = useCallback(({
    target: {
      value
    }
  }) => {
    const shouldExpandByDefault = value === 'expanded';
    if (shouldExpandByDefault) {
      dispatch(expandAll());
    } else {
      dispatch(collapseAll());
    }
    CrmLogger.log('timelineExpandCollapseInteraction', {
      action: shouldExpandByDefault ? 'Clicked Expand All' : 'Clicked Collapse All',
      subjectId,
      type: objectType
    });
    return saveUserSetting(UserSettingsKeys.IS_TIMELINE_EXPANDED_BY_DEFAULT, shouldExpandByDefault);
  }, [dispatch, objectType, subjectId]);
  const handleFilterTimelineByText = useCallback(searchText => {
    const requestPayload = ImmutableMap({
      eventOptions: selectedEventFilters,
      objectType,
      subjectId,
      selectedTeams,
      selectedOwners,
      searchText,
      shouldLimitTimeline: !canViewFullActivityHistory
    });
    CrmLogger.log('timelineInteractions', {
      action: 'filter',
      filterType: 'by search',
      query: searchText
    });
    return TimelineActions.updateTimelineUserAndTeamFilters(objectType, requestPayload);
  }, [canViewFullActivityHistory, objectType, selectedEventFilters, selectedOwners, selectedTeams, subjectId]);
  const renderedExpandCollapseTimelineButtons = useMemo(() => {
    const ValueComponent = () => /*#__PURE__*/_jsx(ExpandCollapseValue, {
      isCollapsedByDefault: isCollapsedByDefault
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
        children: /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "timeline.timelineControls.expandCollapseAllHeading"
          })
        })
      }), /*#__PURE__*/_jsx(Select, {
        buttonUse: "tertiary-light",
        "aria-label": I18n.text('timeline.timelineControls.expandCollapseAllAccessibility'),
        valueComponent: ValueComponent,
        onChange: handleExpandCollapseChange,
        options: [{
          text: I18n.text('timeline.timelineControls.expandCollapseAllToggle.collapseAll'),
          value: 'collapsed'
        }, {
          text: I18n.text('timeline.timelineControls.expandCollapseAllToggle.expandAll'),
          value: 'expanded'
        }]
      })]
    });
  }, [handleExpandCollapseChange, isCollapsedByDefault]);
  const renderedSearchResultsHelpText = useMemo(() => {
    if (!isSearchInUse) {
      return null;
    }
    return /*#__PURE__*/_jsx(View, {
      "data-unit-test": "search-results-text",
      paddingBlock: "200",
      paddingInline: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "timeline.filters.searchResultsText"
      })
    });
  }, [isSearchInUse]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(SetHeightDiv, {
      children: [/*#__PURE__*/_jsx(TimelineSearchInput, {
        objectType: objectType,
        onSearch: handleFilterTimelineByText
      }), /*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        marginInlineStart: "auto",
        paddingInlineStart: "200",
        children: renderedExpandCollapseTimelineButtons
      })]
    }), renderedSearchResultsHelpText]
  });
}
TimelineSearchAndActionsBar.propTypes = {
  isCollapsedByDefault: PropTypes.bool
};
export default WithScopes(TimelineSearchAndActionsBar);